export default "__VITE_ASSET__DCAdwjBV__"